import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { setOrdenamiento } from '../../../slices/filterSlice'
import GenericSelect from '../genericSelect/GenericSelect'

export const OrdenarPor = ({ options }) => {
  const dispatch = useDispatch()

  const { ordenamiento } = useSelector((state) => state.filters)
  const optionsFormateadas = options.map((opcion) => ({
    ...opcion,
    value: JSON.stringify(opcion.value)
  }))

  const valueSeleccionado = JSON.stringify(ordenamiento)

  const cambiarOrdenamiento = (value) => {
    const ordenamiento = JSON.parse(value)
    dispatch(setOrdenamiento(ordenamiento))
  }

  return (
    <GenericSelect
      options={optionsFormateadas}
      value={valueSeleccionado}
      onChange={(value) => {
        cambiarOrdenamiento(value)
      }}
      label="Ordenar por"
      id="ordenar-por"
    />
  )
}

OrdenarPor.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.shape({
        orden: PropTypes.oneOf(['ASC', 'DESC', 'RELEVANTE']).isRequired,
        campo: PropTypes.string.isRequired
      }).isRequired
    })
  ).isRequired
}
